import { defineTemplate } from '../../../../utils';
import { espnTextuales1080x1350 } from './layouts/ESPNTextuales-1080x1350';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/ESPN`;
const LOGOS = `${BASE}/logos`;
const TEXTUALES_THUMB = `${BASE}/ESPN-textuales`;

export const disneyESPNTextuales = defineTemplate({
  mode: 'wysiwyg',
  id: 'espn/espn-textuales',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Textuales',
  templateFamily: 'espn-textuales',
  thumbnail: {
    url: `${TEXTUALES_THUMB}/thumbnail.png`,
    optimizedUrl: `${TEXTUALES_THUMB}/optimized/thumbnail.png`,

    aspectRatio: 'vertical'
  },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'logo',
      label: 'Logo',
      type: 'visual-search-single',
      required: true,
      options: [
        { value: `${LOGOS}/institucional-negro.png`, imageUrl: `${LOGOS}/institucional-negro.png`, label: 'negro' },
        { value: `${LOGOS}/institucional-blanco.png`, imageUrl: `${LOGOS}/institucional-blanco.png`, label: 'blanco' },
        { value: `${LOGOS}/institucional-rojo.png`, imageUrl: `${LOGOS}/institucional-rojo.png`, label: 'rojo' }
      ]
    },
    {
      key: 'background-image',
      label: 'Imagen',
      type: 'image',
      required: true
    },
    {
      key: 'quote',
      label: 'Cita',
      type: 'input',
      multiline: true,
      placeholder: 'Escribí la cita o frase destacada',
      required: true
    },
    {
      key: 'author',
      label: 'Autor de la cita',
      type: 'input',
      placeholder: '¿Quién dijo la frase?',
      required: true
    }
  ],
  canvasBinding: {
    resolutions: [
      {
        id: '1080x1350',
        label: '1080 × 1350',
        canvasWidth: 1080,
        canvasHeight: 1350,
        type: 'image',
        layout: espnTextuales1080x1350
      }
    ],
    fieldBindings: [
      { kind: 'simple', fieldKey: 'logo', pieceId: 'logo', bindingType: 'image-replace' },
      { kind: 'simple', fieldKey: 'background-image', pieceId: 'background-image', bindingType: 'image-replace' },
      { kind: 'simple', fieldKey: 'quote', pieceId: 'quote', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'author', pieceId: 'author', bindingType: 'text' }
    ]
  }
});
